import ApplicationSerializer from "./application";

export default class extends ApplicationSerializer {
  serialize(snapshot, options) {
    const json = super.serialize(snapshot, options);

    delete json.data.attributes["is-from-hprim"];
    delete json.data.attributes["is-from-oru"];

    return json;
  }
}
